import { action } from "typesafe-actions";
import { IStudentReport, IGroupedStudentReport } from "./type";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";




export const  FETCH_STUDENT_REPORT_LIST_PROGRESS = "FETCH_STUDENT_REPORT_LIST_PROGRESS";
export const  FETCH_STUDENT_REPORT_LIST_SUCCESS = "FETCH_STUDENT_REPORT_LIST_SUCCESS";
export const  FETCH_STUDENT_REPORT_LIST_FAILED = "FETCH_STUDENT_REPORT_LIST_FAILED";


export const fetchStudentReportListProgress = () => 
    action(FETCH_STUDENT_REPORT_LIST_PROGRESS);

export const fetchStudentReportListSuccess = (data: IStudentReport[], totalFeeAmount: number, totalPaidFee: number, pendingFee: number) =>
    action(FETCH_STUDENT_REPORT_LIST_SUCCESS, {
        data, totalFeeAmount, totalPaidFee, pendingFee,
    });

export const fetchStudentReportListFailed = () =>
    action(FETCH_STUDENT_REPORT_LIST_FAILED);


export const fetchStudentReportListAsync =
  ( 
       date: IDataTableV2DateState["dates"],
       organizationUUID: string,
        courseUUID?: string,
        batch?: string,
        acedmicYear?: number
       
 ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchStudentReportListProgress()); 

      let url = ""
      if(organizationUUID){
        url+= `&organizations_uuid=${organizationUUID}`
      }
      if(courseUUID){
        url+= `&courses_uuid=${courseUUID}`
      }
       if (batch){
        url+= `&batch=${batch}` 
       }
       if(acedmicYear){
        url+= `&academic_year=${acedmicYear}`
       }
      const res = await api.get(
        `report/get-student-wise-Data?&from_date=${date.fromDate}&to_date=${date.toDate}`+url
      );

      // Get the main student data and fee totals from the API response
      const data: IStudentReport[] = res.data.data.data; // List of students
      const totalFeeAmount = res.data.data.total_fee_amount; // Total fees for all students
      const totalPaidFee = res.data.data.total_paid_fee; // Total amount paid by all students  
      const pendingFee = res.data.data.pending_fee; // Total pending fees for all students

      // Create a list of unique students by grouping the data
      // Each student will have their basic info and an empty children array
      // const groupedData = Object.values(
      //   data.reduce((acc, obj) => {
      //     // If this is the first time we see this student
      //     if (!acc[obj.customer_fact_uuid]) {
      //       // Create a new entry for them with their info and empty children array
      //       acc[obj.customer_fact_uuid] = {
      //         ...obj,
      //         children: [], 
      //       };
      //     }
      //     return acc;
      //   }, {} as Record<string, IGroupedStudentReport>)
      // );

      // // For each student in our grouped list, fetch their detailed fee records
      // const detailedDataPromises = groupedData.map(async (student) => {
      //   try {
      //     // Make API call to get detailed records for this specific student
      //     const detailedRes = await api.get(
      //       `report/get-student-wise-detailed-Data?&from_date=${date.fromDate}&to_date=${date.toDate}&organizations_uuid=${organizationUUID}&customer_fact_uuid=${student.customer_fact_uuid}`
      //     );
      //     // Return student info with their detailed records in the children array
      //     return {
      //       ...student,
      //       children: detailedRes.data.data.query || [], // Use empty array if no details found
      //     };
      //   } catch (error) {
      //     // If there's an error getting details, log it and return student without details
      //     console.error(`Error fetching details for student ${student.customer_fact_uuid}:`, error);
      //     return student;
      //   }
      // });

      // const groupedDataWithDetails = await Promise.all(detailedDataPromises);
      
      dispatch(fetchStudentReportListSuccess(data, totalFeeAmount, totalPaidFee, pendingFee));
       
    } catch (error: any) {
        dispatch(fetchStudentReportListFailed()); 
        dispatch(
            showMessage({
              type: "error",
              message: error.response.data.message,
              displayAs: "snackbar",
            })
        )
    }
}



export const  FETCH_STUDENT_REPORT_DETAIL_LIST_PROGRESS = "FETCH_STUDENT_REPORT_DETAIL_LIST_PROGRESS";
export const  FETCH_STUDENT_REPORT_DETAIL_LIST_SUCCESS = "FETCH_STUDENT_REPORT_DETAIL_LIST_SUCCESS";
export const  FETCH_STUDENT_REPORT_DETAIL_LIST_FAILED = "FETCH_STUDENT_REPORT_DETAIL_LIST_FAILED";


export const fetchStudentReportDetailListProgress = () => 
    action(FETCH_STUDENT_REPORT_DETAIL_LIST_PROGRESS);

export const fetchStudentReportDetailListSuccess = (data: IStudentReport[],  totalRecords: number, totalFeeAmount: number, totalPaidFee: number, pendingFee: number   ) =>
    action(FETCH_STUDENT_REPORT_DETAIL_LIST_SUCCESS, {
        data,totalRecords,totalFeeAmount, totalPaidFee, pendingFee,
    });

export const fetchStudentReportDetailListFailed = () =>
    action(FETCH_STUDENT_REPORT_DETAIL_LIST_FAILED);

export const fetchStudentdeatiledReportListAsync =
  ( 
       date: IDataTableV2DateState["dates"],
       organizationUUID: string,
        courseUUID?: string,
        batch?: string,
        acedmicYear?: number,
        customer_fact_uuid?: string
       
 ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchStudentReportDetailListProgress()); 

      let url =""
      if(organizationUUID){
        url+= `&organizations_uuid=${organizationUUID}`
      }
      if(courseUUID){
        url+= `&courses_uuid=${courseUUID}`
      }
       if (batch){
        url+= `&batch=${batch}` 
       }
       if(acedmicYear){
        url+= `&academic_year=${acedmicYear}`

       }
       if(customer_fact_uuid){
        url+= `&customer_fact_uuid=${customer_fact_uuid}`
       }
      const res = await api.get(
        `report/get-student-wise-detailed-Data?&from_date=${date.fromDate}&to_date=${date.toDate}`+url
      );

      const data: IStudentReport[] = res.data.data.query;
      const totalFeeAmount = res.data.data.total_fee_amount;
        const totalPaidFee = res.data.data.total_paid_fee;
        const pendingFee = res.data.data.pending_fee;

      const singleReport  = res.data.data[0];
        const totalRecords = res.data.totalRecords;
        dispatch(fetchStudentReportDetailListSuccess(data, totalRecords, totalFeeAmount, totalPaidFee, pendingFee));
       
    } catch (error: any) {
        dispatch(fetchStudentReportDetailListFailed()); 
        dispatch(
            showMessage({
              type: "error",
              message: error.response.data.message,
              displayAs: "snackbar",
            })
        )
    }
}
  

export const  CLEAR_STUDENT_REPORT_STATE = "CLEAR_STUDENT_REPORT_STATE";
export const CLEAR_STUDENT_REPORT= "CLEAR_STUDENT_REPORT";

export const clearStudentReportState = () => action(CLEAR_STUDENT_REPORT_STATE);
export const clearStudentReport = () => action(CLEAR_STUDENT_REPORT);


